import {Component} from '@angular/core';
import {SiteEditDialog} from '@app/shared/edit-dialog/site/site-edit-dialog.component';
import { ModalFilter } from '@app/shared/model-table/model-table-filter';
import {WebClient} from '@injectables';
import {op, Subscription} from '@lib/rxjs';
import {Client, Site} from '@models';

@Component({
    selector: 'sites',
    templateUrl: './sites.component.html',
    styleUrls: ['./sites.component.scss']
})
export class SitesComponent {
    constructor(
        private readonly webClient: WebClient,
    ) { }

    private subscriptions: Subscription = new Subscription();
    
    public searchText: string = '';
    public selected: string = 'Name';
    public readonly model = Site;
    public readonly restClient = this.webClient.model.site;
    public readonly editDialog = SiteEditDialog;
    public readonly deletable = (v: Site) => v.name !== 'Strayos_Site';

    // load all clients into a Map for display
    public readonly clients$ = this.webClient.model.client
        .search$({})
        .pipe(
            op.map((values) => new Map(values.map((c) => [c.id, c]))),
            op.startWith(new Map<number, Client>())
    );

    private clientOptions: { value: number; label: string }[] = [];
    public clientsUpdated$ = this.clients$.pipe(
        op.map((clientMap) => {
            const options = Array.from(clientMap.entries()).map(([id, value]) => ({
                value: id,
                label: value.name,
            }));
            return options;
        })
    );

   public ngOnInit(): void {
        this.subscriptions.add(this.clientsUpdated$.subscribe((clients) => {
            this.clientOptions = clients;
            this.addClientsInFilterConfig(this.clientOptions);
        }));
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private addClientsInFilterConfig(
        clientOptions: {
            value: number;
            label: string;
        }[]
    ) {
        if (clientOptions.length > 0) {
            this.filterConfigs.push({
                type: 'select-string',
                dbColumn: 'clientId',
                column: 'Client',
                isValueLabelPair: true,
                options: clientOptions,
            });
        }
    }

    public filterConfigs: ModalFilter[] = [
        {
            type: 'input-string',
            column: 'Name',
            dbColumn: 'name',
        }]
}

